import { fullName } from 'module/helpers/full-name';
import { Breadcrumb } from 'module/ui/components/atoms/breadcrumb';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { Page } from 'module/ui/components/molecules/page';
import { Argon } from 'module/ui/components/templates/argon';
import { useAccountPeopleProfileQuery } from 'queries/account-people';
import { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PeopleProfile } from 'components/organisms/account-people/detail';
import { useAccountPeopleRouteNavigation } from 'components/organisms/account-people/route-navigation';
import { useCompanyFromUrl } from '../use-current-company';

export const AccountPeopleProfilePage = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();
  const { userId: userIdParam } = useParams();
  const userId = parseInt(userIdParam ?? '-1', 10);
  const { data: userProfile, isLoading: isUserProfileLoading } =
    useAccountPeopleProfileQuery(userId);
  const userFullName = useMemo(
    () => (userProfile ? fullName(userProfile.user) : ''),
    [userProfile],
  );
  const { getPeopleListRoute } = useAccountPeopleRouteNavigation();

  if (
    isCompanyLoading ||
    userProfile == null ||
    company == null ||
    isUserProfileLoading
  ) {
    return <PageLoading />;
  }

  return (
    <Argon
      documentTitle={userFullName}
      breadcrumbs={
        <>
          <Breadcrumb.Item>
            <Link to={getPeopleListRoute(company.companyId)}>
              {company.companyName}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>&nbsp;</Breadcrumb.Item>
        </>
      }
      title={<Page.Header.Title>{userFullName}</Page.Header.Title>}
      content={<PeopleProfile userProfile={userProfile} company={company} />}
      actions={{}}
    />
  );
};
